export default "__VITE_ASSET__dcdb42ea__"